export default __webpack_public_path__ + "static/media/piper-goat-crop.e72b6d95.jpg";